import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import RichTextEditor from '../../components/editor/RichTextEditor';
import { mergeStaticContentWithLanguages } from './privacyPolicyConstants';

export default function PrivacyPolicyEditModal({ open, initialRecords, languages, onClose, onSaved }) {
  const [details, setDetails] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) {
      return;
    }
    setError('');
    setDetails(mergeStaticContentWithLanguages(languages, initialRecords || []));
  }, [open, initialRecords, languages]);

  function updateDetail(index, value) {
    setDetails((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], body: value };
      return next;
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      for (const detail of details) {
        await adminApi.updatePrivacyPolicy({
          lang: detail.lang,
          body: detail.body || '',
        });
      }
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err.message || '保存失敗');
    } finally {
      setSubmitting(false);
    }
  }

  if (!open) {
    return null;
  }

  return (
    <div className="confirm-dialog-overlay" role="presentation" onClick={onClose}>
      <div
        className="modal-panel modal-panel--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-panel__header">
          <h3>修改隱私條款</h3>
          <button type="button" className="btn btn-link" onClick={onClose}>
            ×
          </button>
        </div>

        <form className="modal-panel__body static-content-edit-form" onSubmit={handleSubmit}>
          {error ? <p className="form-message form-message--error">{error}</p> : null}

          {details.map((detail, index) => (
            <section key={detail.lang} className="static-content-edit-form__section">
              <h4>{detail._label || detail.lang}</h4>
              <RichTextEditor
                value={detail.body || ''}
                onChange={(value) => updateDetail(index, value)}
                placeholder="請輸入隱私條款內容"
              />
            </section>
          ))}

          <div className="modal-panel__footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
              取消
            </button>
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '保存中…' : '保存'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
